import DerivedDocumentStep from './derivedDocumentStep'
import InternalApprovalStep from './internalApprovalStep'

const stepsSpecs = [
	{
		type: 'internalApproval',
		label: 'Aprovação Interna',
		component: InternalApprovalStep,
		initialState: {
			type: 'internalApproval',
			title: '',
			next_step: null,
			responsible_group: null,
			deadline: null,
		},
	},
	{
		type: 'derivedDocument',
		label: 'Documento Derivado',
		component: DerivedDocumentStep,
		initialState: {
			type: 'derivedDocument',
			title: '',
			template: null,
			add_attachment: null,
			attachment_variable_name: null,
		},
	},
]

class StepFactory {
	getStepSpec(stepType, data) {
		const stepSpec = stepsSpecs.find((step) => step.type === stepType)
		return stepSpec
	}
	getStepsSpecs() {
		return stepsSpecs
	}
}

export default StepFactory
